import { Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
//import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';

import config from '../common/config';
import { CommonProvider } from '../../providers/common/common.provider';

const httpOptions = {
  headers: new HttpHeaders({'Authorization':config.AUTHORIZE_KEY})
};

const siteUrl = config.SERVER_URL;
const apiUrl = siteUrl;

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  currentReq: any;
  password;
  loggedInfo:any = [];
  userHttpOptions:any = [];
  pageLoaded:boolean = true;
  //callFn:any = [];

  constructor(private http: HttpClient, public common: CommonProvider) {
    this.loggedInfo = this.common.getUserInfo();
    /* window.addEventListener('online', () => {
			console.log('Network online');
		}); */
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
    }
    console.log(error);
    // return an observable with a user-facing error message
    let erMsg = (error.error !=undefined && error.error.message!=undefined)?error.error.message:error.message;
    return throwError({error:error.status,message:erMsg});
    //return throwError('Something bad happened; please try again later.');
  }
  
  private extractData(res: Response) {
    let body = res;
    return body || { };
  }

  createAuthorizationHeader(headers: Headers) {
    let userInfo = this.common.getUserInfo();
    headers.append('Authorization', userInfo.authKey); 
  }

  /* storeFn(method,data) {
    this.callFn.push({method:method,data:data});
  } */

  getVersion(): Observable<any> {
    this.common.checkInternet()
    const url = `${config.SERVER_URL_V3}v1/common/mobile/version`;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  checkLogin(data): Observable<any> {
    this.common.checkInternet()
    const url = `${apiUrl}v1/otp`;
    return this.http.post(url, data, httpOptions).pipe(catchError(this.handleError));
  }

  updateAccount(data): Observable<any> {
    this.common.checkInternet()
    const url = `${apiUrl}v1/register/otp`;
    return this.http.post(url, data, httpOptions).pipe(catchError(this.handleError));
  }

  getCities(data): Observable<any> {
    this.common.checkInternet()
    /*const url = `${apiUrl}v1/city`;
    this.pageLoaded = navigator.onLine;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));*/
    let cities:any = [];
    cities = {"code":200,"result":"SUCCESS!!","response":[{"cityUid":2,"cityName":"Bangalore","cityState":"Karnataka","cityCountry":"India","cityRegistrationPercent":1.00,"cityStampdutyPercent":5.60,"cityVatPercent":0.00,"cityServiceTaxPercent":12.00,"cityRoPrefix":"BLR","electricityBillCharge":0,"waterCharge":0,"carParkingMin":100000,"carParkingMax":500000,"otherChargesMin":5.00,"labourCostPercent":25.00,"materialCostPercent":40.00,"otherChargesMax":15.00,"cityLat":12.9716,"cityLong":77.5946,"cityGstPercent":12.00},{"cityUid":1,"cityName":"Chennai","cityState":"Tamil Nadu","cityCountry":"India","cityRegistrationPercent":1.00,"cityStampdutyPercent":7.00,"cityVatPercent":0.00,"cityServiceTaxPercent":12.00,"cityRoPrefix":"CHN","electricityBillCharge":0,"waterCharge":0,"carParkingMin":100000,"carParkingMax":500000,"otherChargesMin":5.00,"labourCostPercent":25.00,"materialCostPercent":7.00,"otherChargesMax":15.00,"cityLat":13.0827,"cityLong":80.2707,"cityGstPercent":12.00},{"cityUid":9,"cityName":"Coimbatore","cityState":"Tamil Nadu","cityCountry":"India","cityRegistrationPercent":1.00,"cityStampdutyPercent":7.00,"cityVatPercent":0.00,"cityServiceTaxPercent":12.00,"cityRoPrefix":"CMB","electricityBillCharge":0,"waterCharge":0,"carParkingMin":100000,"carParkingMax":500000,"otherChargesMin":5.00,"labourCostPercent":25.00,"materialCostPercent":40.00,"otherChargesMax":15.00,"cityLat":11.0168,"cityLong":76.9558,"cityGstPercent":12.00},{"cityUid":4,"cityName":"Hyderabad","cityState":"Andhra Pradesh","cityCountry":"India","cityRegistrationPercent":0.50,"cityStampdutyPercent":4.00,"cityVatPercent":0.00,"cityServiceTaxPercent":12.00,"cityRoPrefix":"HYD","electricityBillCharge":0,"waterCharge":0,"carParkingMin":100000,"carParkingMax":500000,"otherChargesMin":5.00,"labourCostPercent":25.00,"materialCostPercent":40.00,"otherChargesMax":15.00,"cityLat":17.3850,"cityLong":78.4867,"cityGstPercent":12.00},{"cityUid":14,"cityName":"Pune","cityState":"Maharashtra","cityCountry":"India","cityRegistrationPercent":1.00,"cityStampdutyPercent":6.00,"cityVatPercent":0.00,"cityServiceTaxPercent":12.00,"cityRoPrefix":"PUN","electricityBillCharge":0,"waterCharge":0,"carParkingMin":100000,"carParkingMax":500000,"otherChargesMin":5.00,"labourCostPercent":25.00,"materialCostPercent":7.00,"otherChargesMax":15.00,"cityLat":18.5204,"cityLong":73.8567,"cityGstPercent":12.00}],"error":null};
    return of(cities);
  }

  getMetaData(data): Observable<any> {
    this.common.checkInternet()
    return this.http.get(`${apiUrl}v1/metadata`, httpOptions).pipe(catchError(this.handleError));
  }

  getPrefTypes() {
    return config.PREF_PROPERTY_TYPES;
  }

  getPrefBhks() {
    return config.PREF_BHKS;
  }

  getPrefPriceRange() {
    return config.PREF_PRICE_RANGE;
  }

  getPrefPossessions() {
    return config.PREF_POSSESSION;
  }

  getBanner(data): Observable<any> {
    this.common.checkInternet()
    let url = '';
    switch(data.type) {
      case 'homepage':
        url = `${apiUrl}v1/metadata/hp-banner?cityName=`+data.city;
      break;
      case 'offers':
        url = `${apiUrl}v1/sales_banner?city=`+data.city+`&pageType=`+data.pageType;
      break;
    }
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
    //return this.http.get(url, data, httpOptions).pipe(catchError(this.handleError));
  }

  getHomeContent(data): Observable<any> {
    this.common.checkInternet()
    let url = `${apiUrl}v2/banners?city=`+data.city+`&limit=300&offset=0`;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  getFeaturedBuilders(data): Observable<any> {
    this.common.checkInternet()
    let offset = (this.common.validateField(data.offet))?0:data.offset;
    let url = `${apiUrl}v1/builders/featured?city=`+data.city+`&limit=`+data.limit+`&offset=`+offset;
     return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  getSearchSuggest(data): Observable<any> {
    this.common.checkInternet()
    let url = `${apiUrl}v1/suggest?city=`+data.city+`&prefix=`+data.searched;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  async getShortlisted(data): Promise<any> {
    this.common.checkInternet()
		return new Promise(async (resolve) => {
      await this.getShortlists({limit:200,offset:0}).subscribe(res => {
        if(res.code=200) {
          let respContent = res.response;
          let sData = (!this.common.validateField(respContent.listings.message))?respContent.listings.message.result:[];
          resolve(sData);
        } else {
          resolve([]);
        }
      });
    });
  }

  getShortlists(data): Observable<any>{
    this.common.checkInternet()
    let url = `${apiUrl}v1/user/shortlist?limit=`+data.limit+`&offset=`+data.offset;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  addShortlist(data): Observable<any> {
    this.common.checkInternet()
    let url = `${apiUrl}v1/user/shortlist?listingId=`+data.id;
    if(!data.isDelete)
      return this.http.post(url, httpOptions).pipe(catchError(this.handleError));
    else
      return this.http.delete(url, httpOptions).pipe(catchError(this.handleError));
  }

  getPropertySearch(data): Observable<any> {
    this.common.checkInternet()
    //{{URL}}/v1/exact?city=Bangalore&limit=5&offset=0&localities=Bommasandra&priceMin=4000000&priceMax=7000000
    let params = '';
    params += !this.common.validateField(data.city)?`&city=`+data.city:'';
    params += !this.common.validateField(data.locality)?`&localities=`+data.locality:'';
    params += !this.common.validateField(data.builder)?`&builderName=`+data.builder:'';
    params += !this.common.validateField(data.maxBudget)?`&priceMax=`+data.maxBudget:'';
    params += !this.common.validateField(data.filter.propertyType)?`&propertyTypes=`+data.filter.propertyType:'';
    params += !this.common.validateField(data.filter.bhk)?`&bedrooms=`+data.filter.bhk:'';
    
    let url = `${apiUrl}v1/exact?limit=250&offset=0`+params;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  getPropertyDetail(data): Observable<any> {
    this.common.checkInternet()
    //let url = `${apiUrl}v2/listing/detailed?section=one&listingId=`+data.id;
    //let url = `https://roofandfloor.thehindu.com/ksl-api/v3/listing/detail?id=`+data.id+`&section=`+data.section+`&url=`;
    let url = `${config.SERVER_URL_V3}v3/listing/detail?id=`+data.id+`&section=`+data.section+`&url=`;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  updateProfile(data): Observable<any> {
    this.common.checkInternet()
    let url = `${config.SERVER_URL_V3}v3/user/update`;
    return this.http.put(url, data, httpOptions).pipe(catchError(this.handleError));
  }

  contactBuilder(data): Observable<any> {
    this.common.checkInternet()
    let url = `${apiUrl}v1/contact`;
    return this.http.post(url, data, httpOptions).pipe(catchError(this.handleError));
  }

  contactedProperties(data): Observable<any> {
    this.common.checkInternet()
    let url = `${apiUrl}v1/exact?sortparam=sort_algo_g&userId=`+data.uId+`&contacted=CONTACTED`;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  getTruePrice(pId): Observable<any> {
    this.common.checkInternet()
    let url = `${config.SERVER_URL_V3}v3/listing/truePrice?listingId=`+pId;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  getFinalPrice(id): Observable<any> {
    this.common.checkInternet()
    let url = `${config.SERVER_URL}v1/unit/`+id+`/final_price`;
    return this.http.get(url, httpOptions).pipe(catchError(this.handleError));
  }

  checkVersion(data): Observable<{}> {
    this.common.checkInternet()
    let userInfo = this.common.getUserInfo();
    if(!this.common.validateField(userInfo))
      data.password = this.password = userInfo.password;
    const url = `${apiUrl}check-version.php`;
    return this.http.post(url, data, httpOptions).pipe(catchError(this.handleError));
  }
}